import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
    const Tag = motion[as] || motion.div;
    return (
        <Tag
            className={className}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay, ease: "easeOut" }}
        >
            {children}
        </Tag>
    );
};
